import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AuditEvent } from '../models/EventHistoryModels';

export const useEventHistory = () => {
  const { t } = useTranslation();

  const getEventTitle = useCallback(
    (event: AuditEvent): string => {
      switch (event) {
        case AuditEvent.TenantCreate:
          return t('Tenant created');
        case AuditEvent.TenantDelete:
          return t('Tenant deleted');
        case AuditEvent.UserCreate:
          return t('User created');
        case AuditEvent.UserUpdate:
          return t('User updated');
        case AuditEvent.UserDelete:
          return t('User deleted');
        case AuditEvent.UserPasswordReset:
          return t('User password reset');
        case AuditEvent.UserOtpCodeSent:
          return t('Password reset OTP code sent');
        case AuditEvent.UserLocked:
          return t('User locked');
        case AuditEvent.UserLockWarning:
          return t('User lock warning email sent');
        case AuditEvent.UserLockExpired:
          return t('User lock expired');
        case AuditEvent.DomainCreate:
          return t('Domain added');
        case AuditEvent.DomainDelete:
          return t('Domain deleted');
        case AuditEvent.TaniumInstanceCreate:
          return t('Tanium Instance linked');
        case AuditEvent.TaniumInstanceDelete:
          return t('Tanium Instance unlinked');
        case AuditEvent.IdpCreate:
          return t('Identity Provider created');
        case AuditEvent.IdpUpdate:
          return t('Identity Provider updated');
        case AuditEvent.IdpDelete:
          return t('Identity Provider deleted');
        case AuditEvent.GettingStartedEmailSent:
          return t('Getting Started Email Sent');
        case AuditEvent.LinkedInstanceEmailSent:
          return t('Linked Instance Email Sent');
        case AuditEvent.UnlinkedInstanceEmailSent:
          return t('Unlinked Instance Email Sent');
        case AuditEvent.IdpCertExpirationEmailSent:
          return t('Idp Certificate Expiration Email Sent');
        default:
          return '';
      }
    },
    [t]
  );

  return { getEventTitle };
};
